export default __webpack_public_path__ + "static/media/css.aaf3a5ab.svg";